// extracted by mini-css-extract-plugin
module.exports = {"loadingIcon":"local-loading_loadingIcon_3xrPk","local-preloader":"local-loading_local-preloader_3Zii5"};